import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import {IPortMonitorListItem} from 'features/port/model/PortMonitor/IPortMonitor';
import {usePortMonitorDelete} from 'features/port/model/usePortMonitorMutations';
import {getPortMonitorName} from 'features/port/lib/portMonitorHelper';

interface IPortMonitorDeleteModalProps {
    item: IPortMonitorListItem,
    open: boolean,
    handleClose: () => void,
}

const PortMonitorDeleteModal: React.FC<IPortMonitorDeleteModalProps> = ({item, open, handleClose}) => {
    const {remove, isLoading} = usePortMonitorDelete({item, handleClose});

    return (
        <ConfirmModal
            variant="delete"
            open={open}
            handleClose={handleClose}
            header={t`Удаление монитора порта`}
            title={
                <Trans
                    id="modal.portMonitor.delete.title"
                    message="Вы уверены, что хотите удалить монитор порта"
                />
            }
            name={getPortMonitorName(item)}
            hint={
                <Trans
                    id="modal.portMonitor.delete.hint"
                    message="Вместе с монитором удалятся все инциденты этого порта."
                />
            }
            confirmText={t`Удалить`}
            onConfirm={remove}
            isLoading={isLoading}
        />
    );
};

export default PortMonitorDeleteModal;
